/* eslint react/jsx-no-bind:0 */
import React from "react";
import { connect } from "react-redux"
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { reduxForm, formValueSelector, Field, change } from 'redux-form'
import { Col, FormGroup, Button, Row } from "react-bootstrap"
import Dialog from 'react-bootstrap-dialog'
import { resetWizardState, addMixedAgeDivision, savePostEventSetup, deleteEventDivisionHeld } from '../../../../redux/actions/action_postEvent';
import { blue, lightgray, warning, style, gray, red, StatusDescription } from '../../../../utils/constants'
import { onlypositivenumbers } from '../../../../utils/functions';
import { renderCheckboxField } from '../../../../modules/components/checkboxfieldcomponent';
import { renderOptionsField } from '../../../../modules/components/fieldoptioncomponent';
//import { renderEarpField } from '../../../../modules/components/earpfieldcomponent';
import { STEP_SEQUENCE } from '../../logic';

const formName = 'postevent'
const sectionBorder = {
  border: `1px solid ${gray}`,
  padding: '15px',
  marginRight: '0px',
  marginBottom: '15px'
};

class PostEventSetup extends React.Component {
  constructor() {
    super();
    this.state = {
    };

    this.renderField = this.renderField.bind(this);
    this.generateMixedAgeDivisionsOfferedSection = this.generateMixedAgeDivisionsOfferedSection.bind(this);
    this.handleAddMixedAgeDivision = this.handleAddMixedAgeDivision.bind(this);
    this.saveSetup = this.saveSetup.bind(this);
    this.handleRemoveDivisionHeld = this.handleRemoveDivisionHeld.bind(this);
    this.deleteDivisionHeld = this.deleteDivisionHeld.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.props.dispatch(resetWizardState(STEP_SEQUENCE.PostEventSetup));
  }

  handleAddMixedAgeDivision() {
    const { dispatch } = this.props;
    dispatch(addMixedAgeDivision())
  }

  renderField(field) {
    return (
      <div className='form-group'>
        <Col className={field.inputattrs}>
          <input
            className="form-control"
            placeholder={field.placeholder ? field.placeholder : ''}
            type={field.type ? field.type : 'text'}
            {...field.input}
            disabled={field.disabled}
            pattern={field.pattern ? field.pattern : ''}
            maxLength={field.maxLength ? field.maxLength : ''}
          />
        </Col>
      </div>);
  }

  saveSetup() {
    const {
      eventId,
      eventTypeId,
      mixedAgeDivisionsHeld,
      eventseason,
      seasons
    } = this.props;

    const currentseason = seasons.filter(s => s.id === eventseason);
    const setup = {
      season: currentseason.length > 0 ? currentseason[0] : null,
      eventId: eventId,
      eventTypeId: eventTypeId,
      step: STEP_SEQUENCE.PostEventSetup,
      divisionsHeld: mixedAgeDivisionsHeld,
      mixedAgeDivisionsHeld
    }
    this.props.dispatch(savePostEventSetup(eventId, setup))
  }

  deleteDivisionHeld(divisionId) {
    const { dispatch, eventId, mixedAgeDivisionsHeld } = this.props;
    if (divisionId !== undefined && divisionId > 0) {
      dispatch(deleteEventDivisionHeld(eventId, divisionId));
    }
    else {
      const divisions = [...mixedAgeDivisionsHeld];
      divisions.pop();
      dispatch(change(formName, 'mixedAgeDivisionsHeld', divisions))
    }
  }

  handleRemoveDivisionHeld(Id) {
    const { mixedAgeDivisionsHeld } = this.props;

    const customBody = (
      <p>
        <i className="fa fa-exclamation-triangle text-danger" style={{ color: 'red' }} />
        &nbsp;&nbsp;
        <span>Are you sure you want to delete this division? </span>
      </p>
    )
    const customBody1 = (
      <p>
        <i className="fa fa-exclamation-triangle text-danger" style={{ color: 'red' }} />
        &nbsp;&nbsp;
        <span>Division can not be removed because there are still Advancers/Alternates assigned to the Division. </span>
      </p>
    )
    Dialog.setOptions({
      defaultOkLabel: 'Delete',
      defaultCancelLabel: 'Cancel',
      primaryClassName: 'btn-danger'
    })
    Dialog.Action(
      'Delete Division',
      () => this.deleteDivisionHeld(Id),
      'btn-danger'
    )

    for (let i = 0; i < mixedAgeDivisionsHeld.length; i++) {
      if (mixedAgeDivisionsHeld[i].id == Id && (mixedAgeDivisionsHeld[i].advancers.length > 0 || mixedAgeDivisionsHeld[i].alternates.length > 0)) {
        this.dialog.show({
          body: customBody1,
          actions: [
            Dialog.CancelAction()
          ],
          bsSize: 'small'
        })
        break;
      }

      for (let i = 0; i < mixedAgeDivisionsHeld.length; i++) {
        if (mixedAgeDivisionsHeld[i].id == Id && (mixedAgeDivisionsHeld[i].advancers.length == 0 || mixedAgeDivisionsHeld[i].alternates.length == 0)) {
          this.dialog.show({
            body: customBody,
            title: 'Delete Division',
            actions: [
              Dialog.CancelAction(),
              Dialog.OKAction(() => this.deleteDivisionHeld(Id))
            ],
            bsSize: 'small'
          })
        }
      }
    }
  }

  generateMixedAgeDivisionsOfferedSection() {
    const { mixedAgeDivisionsHeld, roleName, seasons, status } = this.props;
    const offered = mixedAgeDivisionsHeld.map((division, index) => {

      let ratio;
      const advRatio = mixedAgeDivisionsHeld[index].advancerRatio;
      const minAdvancerRatio = seasons[0].minAdvancerRatio;
      const maxAdvancerRatio = seasons[0].maxAdvancerRatio;
      const policyAdvancer = mixedAgeDivisionsHeld[index].advancerPolicy;
      if (policyAdvancer === '0' && ((parseInt(advRatio) <= parseInt(minAdvancerRatio)) || (parseInt(advRatio) > parseInt(maxAdvancerRatio)))) {
        ratio = minAdvancerRatio;
      } else if (policyAdvancer === '1') {
        ratio = 1;
      } else {
        ratio = advRatio;
      }
      mixedAgeDivisionsHeld[index].advancerRatio = ratio;
      const advancerRatio = `mixedAgeDivisionsHeld[${index}].advancerRatio`;
      const { divisions } = division;
      const divisionName = `mixedAgeDivisionsHeld[${index}].name`;
      const advancerPolicy = `mixedAgeDivisionsHeld[${index}].advancerPolicy`;
      const includeEnhancedAdvancerRatio = `mixedAgeDivisionsHeld[${index}].includeEnhancedAdvancerRatio`;
      const enhancedAdvancerRatioPolicy = (mixedAgeDivisionsHeld[index].includeEnhancedAdvancerRatio) + index;
      const total = `mixedAgeDivisionsHeld[${index}].total`;
      const member = `mixedAgeDivisionsHeld[${index}].member`;
      const divisionId = mixedAgeDivisionsHeld[index].id;
      const isNotNew = (mixedAgeDivisionsHeld[index].id > 0);
      const divisionHeldName = (mixedAgeDivisionsHeld[index].name) + index;
      const ratioPolicy = (mixedAgeDivisionsHeld[index].advancerPolicy === '0' ? true : false);
      const isAdministrator = roleName == 'Administrator';
      return (
        <FormGroup className='container-fluid col-sm-12' id={index} key={index + 7} style={{ padding: '15px', margin: '10px', border: `1px solid ${gray}` }}>
          <Dialog ref={(el) => { this.dialog = el }} />
          <div className="row">
            <label className="col-sm-2 col-md-2 col-lg-2 control-label">Division:</label>
            {isNotNew &&
              <div className="col-sm-2 col-md-2 col-lg-2 ">
                <Field
                  name={divisionName}
                  type="text"
                  label={divisionName}
                  component={this.renderField}
                  disabled
                />
              </div>
            }
            <div className='cols-sm-8 col-md-8 col-lg-8'>
              {
                divisions.map((madivision, indx) => {
                  const fieldDivisionName = `mixedAgeDivisionsHeld[${index}].divisions[${indx}].selected`;
                  const label = mixedAgeDivisionsHeld[index].divisions[indx].name;
                  const checked = mixedAgeDivisionsHeld[index].divisions[indx].selected;
                  return (
                    <Field
                      key={indx + 15}
                      inputattrs={style.inputattrs1}
                      colWidth='col-sm-1'
                      name={fieldDivisionName}
                      label={label}
                      checked={checked}
                      value={checked}
                      maxWidth='70px'
                      labelColor={blue}
                      component={renderCheckboxField}
                      disabled={isNotNew}
                    />)
                })
              }
            </div>
          </div>
          <div className='row' style={{ marginTop: '10px' }}>
            <label className="col-sm-2 col-md-2 col-lg-2 control-label">Advancer Policies:</label>
            <div className='col-sm-10 col-md-10 col-lg-10' style={{ padding: '0' }}>
              <Field
                inputattrs={style.inputattrs}
                name={advancerPolicy}
                id={divisionHeldName}
                component={renderOptionsField}
                values={[
                  { name: 'Champion Only', abbreviation: '1' },
                  { name: 'Advancer Ratio', abbreviation: '0' },
                ]}
                defaultvalue={advancerPolicy}
                disabled={isNotNew}
              />
            </div>
          </div>
          {
            ratioPolicy &&
            (
              <div className='row'>
                <label className="col-sm-2 col-md-2 col-lg-2 control-label">Ratio 1:</label>
                <div className="col-sm-1 col-md-1 col-lg-1 ">
                  <Field
                    name={advancerRatio}
                    type="number"
                    label={advancerRatio}
                    component={this.renderField}
                    onKeyPress={onlypositivenumbers}
                    disabled={isNotNew}
                    placeholder='##'
                    style={{ maxWidth: '50px' }}
                  />
                </div>
              </div>
            )}
          {
            ratioPolicy &&
            (<div className='row' style={{ marginTop: '10px' }}>
              <label className="col-sm-2 col-md-2 col-lg-2 control-label">Was Enhanced Advancer Ratio Policy (EARP) used?</label>
              <Field
                inputattrs={style.inputattrs}
                name={includeEnhancedAdvancerRatio}
                id={enhancedAdvancerRatioPolicy}
                component={renderOptionsField}
                values={[
                  { name: 'Yes', abbreviation: '1' },
                  { name: 'No', abbreviation: '0' },
                ]}
                defaultvalue={includeEnhancedAdvancerRatio}
                disabled={isNotNew}
              />
              <span style={{ fontSize: '13.5px', fontWeight: 'bold', textDecoration: 'underline', color: 'rgb(159,96,0)', display: 'inline-block' }}>
                <span className="fa fa-info-circle" aria-hidden="true" style={{ display: 'inline-block' }} />&nbsp;<a href="http://usbcongress.http.internapcdn.net/usbcongress/bowl/tournaments/pdfs/usbcjuniorgoldchamp/EARP.pdf" target="blank" >Click here to view the full EARP policy</a>&nbsp;
              </span></div>)
          }
          <div className='row'>
            <label className="col-sm-2 col-md-2 col-lg-2 control-label" style={{ marginBottom: '10px' }}>Division Participants:</label>
          </div>
          <div className='row'>
            <label className="col-sm-2 col-md-2 col-lg-2 control-label">Total Participants:</label>
            <div className="col-sm-1 col-md-1 col-lg-1 ">
              <Field
                name={total}
                type="number"
                label={total}
                component={this.renderField}
                disabled={isNotNew}
                onKeyPress={onlypositivenumbers}
                style={{ maxWidth: '50px' }}
              />
            </div>
          </div>
          <div className='row'>
            <label className="col-sm-2 col-md-2 col-lg-2 control-label">Junior Gold Participants:</label>
            <div className="col-sm-1 col-md-1 col-lg-1 ">
              <Field
                name={member}
                type="number"
                label={member}
                component={this.renderField}
                onKeyPress={onlypositivenumbers}
                disabled={isNotNew}
                style={{ maxWidth: '50px' }}
              />
            </div>
          </div>
          <div className='row' style={{ margin: '0 auto' }}>
            <button type='button' className="btn btn-default" style={{ color: red, fontWeight: 800 }} onClick={() => this.handleRemoveDivisionHeld(divisionId)}
              disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}>
              <i className="fa fa-remove" aria-hidden="true" /> &nbsp;&nbsp;Remove
            </button>
          </div>
        </FormGroup>)
    })
    return offered;
  }

  generateUpdateErrors(eventSetupErrors) {
    const error = eventSetupErrors.map((key, index) => {
      return (<li key={index} style={{ color: warning }}>{this.props.updateSetupErrors[key]}</li>)
    })
    return error;
  }

  render() {
    const { eventname,
      updateSetupErrors,
      currentWizardStep,
      saveComponentState,
      roleName,
      status,
      componentStateSaved
    } = this.props;

    const isAdministrator = roleName == 'Administrator';

    const eventSetupErrors = Object.keys(updateSetupErrors);

    if (currentWizardStep === STEP_SEQUENCE.PostEventSetup) {
      if ((saveComponentState === true) && (componentStateSaved === false)) {
        this.saveSetup();
      }
      if (componentStateSaved === true) {
        this.props.onComponentStateSaved(componentStateSaved)
      }
      if (eventSetupErrors.length > 0) {
        this.props.onComponentStateSaved(false)
      }
    }

    return (
      <div style={{ marginTop: '1%' }} sm={12}>
        <form className="form-horizontal" sm={12} style={{ border: `1px solid ${gray}`, padding: '15px', marginRight: '0px', marginBottom: '15px' }} >
          <Row>
            <Col sm={12} >
              <FormGroup style={{ padding: '0 0 0px 25px', margin: '0' }}>
                <h4 className='text-left' style={{ color: blue }}>{' '}Event Name - {eventname}</h4>
              </FormGroup>
              <FormGroup style={{ padding: '15px', margin: '10px', border: `1px solid ${lightgray}` }}>
                {
                  eventSetupErrors.length > 0 &&
                  (<Col sm={12} style={sectionBorder}>
                    <h4 style={{ color: warning }}>* Please correct the following errors to proceed:</h4>
                    <ul>
                      {
                        this.generateUpdateErrors(eventSetupErrors)
                      }
                    </ul>
                  </Col>)
                }
                <h5 className='col-sm-2' style={{ marginLeft: '0', marginBottom: '15px' }}>Divisions Held</h5>
                {
                  this.generateMixedAgeDivisionsOfferedSection()
                }
                <FormGroup style={{ paddingLeft: '15px', paddingBottom: '0', marginLeft: '10px' }} className='col-sm-12'>
                  <Button className='btn btn-warning' onClick={this.handleAddMixedAgeDivision} style={{ marginLeft: '0', marginBottom: '15px', marginTop: '7px' }}
                    disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}><i className="fa fa-plus"
                    />&nbsp;&nbsp;Add Division Held</Button>
                </FormGroup>
              </FormGroup>
            </Col>
          </Row>
        </form>
      </div>
    )
  }
}

PostEventSetup.propTypes = {
  dispatch: PropTypes.func,
  mixedAgeDivisionsHeld: PropTypes.array,
  eventname: PropTypes.string,
  errors: PropTypes.object,
  addMixedAgeDivision: PropTypes.func,
  seasons: PropTypes.array,
  eventseason: PropTypes.number,
  eventId: PropTypes.number,
  currentWizardStep: PropTypes.number,
  saveComponentState: PropTypes.bool,
  componentStateSaved: PropTypes.bool,
  onComponentStateSaved: PropTypes.func,
  savePostEventSetup: PropTypes.func,
  eventTypeId: PropTypes.number,
  updateSetupErrors: PropTypes.object,
  roleName: PropTypes.string,
  status: PropTypes.string
}
function mapStateToProps(state, ownProps) {
  const formName = ownProps.form;
  const selector = formValueSelector(formName);
  const eventId = selector(state, 'eventId');
  const eventTypeId = selector(state, 'eventTypeId');
  const componentStateSaved = selector(state, 'componentStateSaved');
  const currentWizardStep = selector(state, 'currentWizardStep');
  const eventname = selector(state, 'eventname');
  const mixedAgeDivisionsHeld = selector(state, 'mixedAgeDivisionsHeld');
  const seasons = selector(state, 'seasons');
  const eventseason = selector(state, 'eventseason');
  const updateSetupErrors = selector(state, 'updateSetupErrors');
  const status = selector(state, 'status')
  const roleName = state.user.roleName
  return {
    eventId,
    eventTypeId,
    componentStateSaved,
    currentWizardStep,
    eventname,
    mixedAgeDivisionsHeld,
    seasons,
    eventseason,
    updateSetupErrors,
    roleName,
    status
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    resetWizardState,
    addMixedAgeDivision,
    savePostEventSetup,
    deleteEventDivisionHeld
  }, dispatch)
}

export default reduxForm({
  form: formName,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false
})(connect(mapStateToProps, mapDispatchToProps)(PostEventSetup))



// WEBPACK FOOTER //
// ./src/containers/postevent/components/setup/index.js